function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.65 9.017 31 8.92V7.067h2.78l-2.027-1.89 1.475-1.385c.537.62 1.21 1.215 1.778 1.873L35.11 3h1.872l.093 2.663 1.813-2 1.444 1.497c-.63.565-1.223 1.234-1.866 1.818l2.67.087v1.843l-2.641.08 1.958 1.742-1.476 1.512-1.846-1.923L37.032 13h-1.89v-2.747L33.16 12.16l-1.296-1.338 1.788-1.806zm2.834-.055 2.467 2.538.63-.694-2.554-2.46h3.527v-.707l-3.5-.071 2.48-2.478-.63-.58-2.433 2.521-.074-3.473h-.662l-.08 3.488-2.442-2.558-.637.7 2.519 2.476h-3.527c.019.265 0 .401 0 .682l3.552.124-2.482 2.353.521.612 2.577-2.527v3.542h.661l.087-3.488zM16.77 25.34a3.75 3.75 0 0 1-2.66-6.41 3.71 3.71 0 0 1 2.64-1.09 3.75 3.75 0 0 1 0 7.5h.02zm0-6.79a3 3 0 1 0 0 6 3 3 0 0 0 0-6z",
  fill: "#E4ECFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.75 23.03a1.45 1.45 0 1 1 0-2.9 1.45 1.45 0 0 1 0 2.9z",
  stroke: "#E4ECFF",
  strokeWidth: 0.8
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.75 25.34a3.75 3.75 0 0 1-2.66-6.41 3.71 3.71 0 0 1 2.64-1.09 3.75 3.75 0 0 1 0 7.5h.02zm0-6.79a3.06 3.06 0 0 0-3 3 3 3 0 1 0 3-3z",
  fill: "#E4ECFF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.75 23.03a1.45 1.45 0 1 1 0-2.9 1.45 1.45 0 0 1 0 2.9z",
  stroke: "#E4ECFF",
  strokeWidth: 0.8
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M2.14 21.72h-2v-7.6h77.67l-.1 4h-3.65l-.26 1.54-1.52-.13-.83-1.33-6.05-.09-.16-.75h-6.89L44.63 20.3H20.5l-.09-.24a3.83 3.83 0 0 0-3.68-2.45 4.07 4.07 0 0 0-3.53 2.54l-.09.23h-2.75l-.1-.22a4.13 4.13 0 0 0-3.48-2.53h-.06a3.891 3.891 0 0 0-3.43 2.28l-.09.22H2.14v1.59zM.91 21h.54v-1.6h1.31a4.65 4.65 0 0 1 4.07-2.5 4.76 4.76 0 0 1 4 2.75h1.81a4.7 4.7 0 0 1 4.08-2.76A4.58 4.58 0 0 1 21 19.57h23.6l13.72-2.94h7.5l.17.76 5.87.09.85 1.35h.5l.25-1.48h3.56l.07-2.56H.91V21z",
  fill: "#E4ECFF"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M77.27 15.2H.52v.72h76.75v-.72zM42.91 19.56h-1.28v-2.88h1.28v2.88zm-.92-.36h.56v-2.16h-.56v2.16zM36.31 19.56h-1.29v-2.88h1.29v2.88zm-.93-.36h.53v-2.16h-.57l.04 2.16zM29.73 19.56h-1.28v-2.88h1.28v2.88zm-.92-.36h.56v-2.16h-.56v2.16zM23.16 19.56h-1.25v-2.88h1.28l-.03 2.88zm-.92-.36h.56v-2.16h-.56v2.16zM12.33 19.56h-1.28v-2.88h1.28v2.88zm-.92-.36h.56v-2.16h-.56v2.16zM1.61 19.98H.33v-4h1.28v4zm-.92-.36h.56V16.3H.69v3.32zM63.79 24.28h-2.17v-4.12h2.14l.03 4.12zm-1.45-.72h.72v-2.7h-.71l-.01 2.7z",
  fill: "#E4ECFF"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M64.34 24.9h-3.32v-1.27l3.32.02v1.25zM77.91 14.26H0V0h77.91v14.26zM.72 14h76.47V.72H.72V14z",
  fill: "#E4ECFF"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M77.74 1.35H.58v.72h77.16v-.72zM64.27 20.67h-2.89l-2.91-4.06h7.47l-1.67 4.06zm-2.52-.72h2l1.16-2.65h-5l1.84 2.65z",
  fill: "#E4ECFF"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M77.5 13h1A3.5 3.5 0 0 0 82 9.5M77.5 1H81a1 1 0 0 1 1 1v.5m0 0h-2v7h2m0-7v7",
  stroke: "#E4ECFF"
});

var SvgReeferTrailer = function SvgReeferTrailer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 26,
    viewBox: "0 0 83 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReeferTrailer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reeferTrailer.68888928.svg";
export { ForwardRef as ReactComponent };